import React, { FC, ReactNode } from 'react'
import { Check, Cross, Td, TdHeadline } from './styled'

type Props = {
  headline: string | ReactNode
  text: string | ReactNode
  check?: boolean
}

const TableCell: FC<Props> = ({ headline, text, check = true }) => (
  <Td>
    {check ? <Check /> : <Cross />}
    <TdHeadline>{headline}</TdHeadline>
    {text}
  </Td>
)

export default TableCell
